// extracted by mini-css-extract-plugin
export default {"box":"HZ0rljX6RYB8HAQOL5Bz"};